import { IntlShape } from 'react-intl';
import { validateRequiredField } from 'utils/validation';
import { validatePasswordStrength } from '../validatePasswordStrength';

export const password = (intl: IntlShape, isLogin = false) => {
  const required = validateRequiredField(intl);
  const strength = validatePasswordStrength(intl, isLogin);

  return {
    validate: (value: string) => {
      const requiredResult = required.validate(value);
      return requiredResult === true
        ? strength.validate(value)
        : requiredResult;
    },
  };
};
